/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfoLink_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbShipping_user$ref: FragmentReference;
export type PdpSharedBlurbShipping_user = {|
  +$fragmentRefs: PdpSharedShippingInfoLink_user$ref,
  +$refType: PdpSharedBlurbShipping_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e14ca0cb449ef7dd63b496356308e5ea';
module.exports = node;
